<script>
  import { pcd, api, apply, unitprice, maxunits, quantityoptions, addressinput, msg, messages, unitdetails, applypageheader, salesdatailstitles, quantityfield } from "../stores.js";
  import validator from "../validator.js";
  import { onMount } from "svelte";
  import { parse } from "qs";
  import { querystring, push } from "svelte-spa-router";

  let loading = false;
  let alertmsg = "";
  let validzips = [];
  let prefectureoptions = [];
  let cityoptions = [];
  let updateValidatedClass = (elm, invalid) => {
    if (invalid) {
      if (elm.classList.contains("valid")) elm.classList.remove("valid");
      if (!elm.classList.contains("invalid")) elm.classList.add("invalid");
    } else {
      if (elm.classList.contains("invalid")) elm.classList.remove("invalid");
      if (!elm.classList.contains("valid")) elm.classList.add("valid");
    }
    if (!elm.classList.contains("validated")) elm.classList.add("validated");
  };
  let lastname = {
    input: {
      value: $apply.lastname,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = lastname.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "氏名漢字（姓）を入力してください。";
      } else if (50 < v.length || !validator.isNotContainHalfWidthChara(v)) {
        m = "氏名漢字（姓）は全角５０文字以内で入力してください。";
      } else {
        let ngchars = validator.getOutOfSjisChars(v);
        if (ngchars && 0 < ngchars.length) {
          m = "氏名漢字（姓）にご登録できない文字が含まれています。（" +　ngchars.join(', ') + "）";
        }
      }
      updateValidatedClass(lastname.input, m);
      lastname.invalidmsg = m;
      return this;
    },
  };
  let firstname = {
    input: {
      value: $apply.firstname,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = firstname.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "氏名漢字（名）を入力してください。";
      } else if (50 < v.length || !validator.isNotContainHalfWidthChara(v)) {
        m = "氏名漢字（名）は全角５０文字以内で入力してください。";
      } else {
        let ngchars = validator.getOutOfSjisChars(v);
        if (ngchars && 0 < ngchars.length) {
          m = "氏名漢字（名）にご登録できない文字が含まれています。（" +　ngchars.join(', ') + "）";
        }
      }
      updateValidatedClass(firstname.input, m);
      firstname.invalidmsg = m;
      return this;
    },
  };
  let lastnamekana = {
    input: {
      value: $apply.lastnamekana,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = lastnamekana.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "氏名カナ（姓）を入力してください。";
      } else if (50 < v.length || !validator.isOnlyFullWidthKatakana(v)) {
        m = "氏名カナ（姓）は全角カナ５０文字以内で入力してください。";
      }
      updateValidatedClass(lastnamekana.input, m);
      lastnamekana.invalidmsg = m;
      return this;
    },
  };
  let firstnamekana = {
    input: {
      value: $apply.firstnamekana,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = firstnamekana.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "氏名カナ（名）を入力してください。";
      } else if (50 < v.length || !validator.isOnlyFullWidthKatakana(v)) {
        m = "氏名カナ（名）は全角カナ５０文字以内で入力してください。";
      }
      updateValidatedClass(firstnamekana.input, m);
      firstnamekana.invalidmsg = m;
      return this;
    },
  };
  let zipcode = {
    input: {
      value: $apply.zipcode,
    },
    invalidmsg: "",
    validate: async function () {
      let m = "";
      let v = zipcode.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "郵便番号を入力してください。";
      } else if (7 != v.length || !validator.isOnlyNumeric(v)) {
        m = "郵便番号は半角数字７桁で入力してください。";
      } else {
        let excuted = await zip2add();
        if (excuted && !validzips.includes(v)) m = "郵便番号に該当する住所が見つかりませんでした。";
      }
      updateValidatedClass(zipcode.input, m);
      zipcode.invalidmsg = m;
      return this;
    }
  };
  let prefecture = {
    input: {
      value: $apply.prefecture,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = prefecture.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        if (1 < prefectureoptions.length) {
          m = "都道府県を選択してください。";
        } else {
          m = "郵便番号から住所を入力してください。";
        }
      }
      updateValidatedClass(prefecture.input, m);
      prefecture.invalidmsg = m;
      return this;
    },
  };
  let city = {
    input: {
      value: $apply.city,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = city.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        if (1 < cityoptions.length) {
          m = "市区町村を選択してください。";
        } else {
          m = "郵便番号から住所を入力してください。";
        }
      }
      updateValidatedClass(city.input, m);
      city.invalidmsg = m;
      return this;
    },
  };
  let address = {
    input: {
      value: $apply.address,
    },
    invalidmsg: "",
    validate: function () {
      if (!$addressinput) return this;
      let m = "";
      let v = address.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "番地以降を入力してください。";
      } else if (50 < v.length || !validator.isNotContainHalfWidthChara(v)) {
        m = "番地以降は全角５０文字以内で入力してください。";
      } else {
        let ngchars = validator.getOutOfSjisChars(v);
        if (ngchars && 0 < ngchars.length) {
          m = "番地以降にご登録できない文字が含まれています。（" +　ngchars.join(', ') + "）";
        }
      }
      updateValidatedClass(address.input, m);
      address.invalidmsg = m;
      return this;
    },
  };
  let tel = {
    input: {
      value: $apply.tel,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = tel.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "電話番号を入力してください。";
      } else if (20 < v.length || !validator.isOnlyNumeric(v)) {
        m = "電話番号は半角数字２０桁以内で入力してください。";
      }
      updateValidatedClass(tel.input, m);
      tel.invalidmsg = m;
      return this;
    },
  };
  let age = {
    input: {
      value: $apply.age,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = age.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "年代を選択してください。";
      }
      updateValidatedClass(age.input, m);
      age.invalidmsg = m;
      return this;
    },
  };
  let gender = {
    input: {
      value: $apply.gender,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = gender.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "性別を選択してください。";
      }
      updateValidatedClass(gender.input, m);
      gender.invalidmsg = m;
      return this;
    },
  };
  let quantity = {
    input: {
      value: $apply.quantity,
    },
    invalidmsg: "",
    validate: function () {
      let m = "";
      let v = quantity.input.value;
      if (!v || v.length === 0 || v.trim().length === 0) {
        m = "申込セット数を選択してください。";
      }
      updateValidatedClass(quantity.input, m);
      quantity.invalidmsg = m;
      return this;
    },
  };
  let forminputs = [
    lastname,
    firstname,
    lastnamekana,
    firstnamekana,
    zipcode,
    prefecture,
    city,
    address,
    tel,
    age,
    gender,
    quantity,
  ];

  onMount(async () => {
    window.scroll(0, 0);
    let q = parse($querystring);
    if ((!q || !q.t) && !$apply.t) push("/");
    if (($apply.t && !q.t) || (q.t == $apply.t)) {
      lastname.input.value = $apply.lastname;
      firstname.input.value = $apply.firstname;
      lastnamekana.input.value = $apply.lastnamekana;
      firstnamekana.input.value = $apply.firstnamekana;
      zipcode.input.value = $apply.zipcode;
      await zip2add();
      prefecture.input.value = $apply.prefecture;
      city.input.value = $apply.city;
      address.input.value = $apply.address;
      tel.input.value = $apply.tel;
      age.input.value = $apply.age;
      gender.input.value = $apply.gender;
      quantity.input.value = $apply.quantity;
      return;
    }
    try {
      const response = await fetch($api + "/entry?" + $querystring);
      const data = await response.json().catch(() => null);
      if (response.status == 200) {
        $apply.t = q.t;
        if (data) {
          if (data.pcd && data.pcd != $pcd) {
            $msg = "この申込みURLは、有効期限切れ、もしくはご使用済みのため、無効になっております。\n再度メールアドレス登録からお手続きを行っていただけますようお願いいたします。";
            push("/message");
            return;
          }
          if (data.email) $apply.email = data.email;
          if (data.title) $apply.salestitle = data.title;
          if (data.term) $apply.salesterm = data.term;
        }
      } else if (response.status == 424) {
        $msg = data.message;
        push("/message");
      } else if (response.status == 422) {
        $msg = "この申込みURLは、有効期限切れ、もしくはご使用済みのため、無効になっております。\n再度メールアドレス登録からお手続きを行っていただけますようお願いいたします。";
        push("/message");
        return;
      } else if ([429, 504].includes(response.status)) {
        $msg = $messages.busy;
        push("/message");
        return;
      } else {
        push("/error");
        return;
      }
    } catch (err) {
      push("/error");
    }
  });

  async function zip2add() {
    if (loading) return false;
    try {
      loading = true;
      const z = $apply.zipcode;
      const response = await fetch($api + "/zip/" + z);
      const data = await response.json().catch(() => null);
      if (data && data.adds && 0 < data.adds.length) {
        validzips.push(z);
        prefectureoptions = Array.from(new Set(data.adds.map(a => a.pref)));
        cityoptions = data.adds.map(a => a.city + a.town);
        if (!$apply.prefecture || !prefectureoptions.includes($apply.prefecture)) $apply.prefecture = prefectureoptions[0];
        if (!$apply.city || !cityoptions.includes($apply.city)) $apply.city = cityoptions[0];
      } else {
        prefectureoptions = [];
        cityoptions = [];
      }
    } catch (err) {
      console.debug(err);
    } finally {
      loading = false;
    }
    return true;
  }

  async function handleSubmit(e) {
    let validateResults = [];
    for (let i = 0; i < forminputs.length; i++) {
      const r = await forminputs[i].validate();
      validateResults.push(r.invalidmsg);
    }
    if (validateResults.some((v) => 0 < v.length)) return;
    push("/confirm");
  }
</script>

<style>
  .unselectable {
    display: none;
  }
  .btn-primary {
    min-width: 8.25rem;
  }
</style>

<div class="row">
  <div class="col twelve">
    <h2>{$applypageheader}</h2>
  </div>
  {#if alertmsg && 0 < alertmsg.length}
  <div class="alert">{alertmsg}</div>
  {/if}
  <dl class="row mb-1 w100">
    <dt class="col two">{$salesdatailstitles.name}</dt><dd class="col ten">{$apply.salestitle}</dd>
    <dt class="col two">{$salesdatailstitles.term}</dt><dd class="col ten">{$apply.salesterm}</dd>
    <dt class="col two">{$salesdatailstitles.item}</dt><dd class="col ten">{$unitdetails}</dd>
    <dt class="col two">{$salesdatailstitles.price}</dt><dd class="col ten">{$unitprice.toLocaleString('ja-JP')}円／1セット</dd>
    <dt class="col two">{$salesdatailstitles.limitation}</dt><dd class="col ten">1セット～{$maxunits}セット</dd>
  </dl>
  <form on:submit|preventDefault={handleSubmit} novalidate class="w100">
    <div class="input-group">
      <div class="col three"><label for="email">メールアドレス</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.email}
          id="email"
          class="w100" />
      </div>
    </div>
    <fieldset>
      <legend>氏名（漢字）</legend>
      <div class="input-group">
        <div class="col three"><label for="lastname">姓</label></div>
        <div class="col nine">
          <input
            type="text"
            required
            bind:this={lastname.input}
            bind:value={$apply.lastname}
            on:blur={lastname.validate}
            id="lastname"
            placeholder="姓"
            class="w100" />
          <div class="ifinvalid">{lastname.invalidmsg}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="col three"><label for="firstname">名</label></div>
        <div class="col nine">
          <input
            type="text"
            required
            bind:this={firstname.input}
            bind:value={$apply.firstname}
            on:blur={firstname.validate}
            id="firstname"
            placeholder="名"
            class="w100" />
          <div class="ifinvalid">{firstname.invalidmsg}</div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>氏名（カナ）</legend>
      <div class="input-group">
        <div class="col three"><label for="lastnamekana">セイ</label></div>
        <div class="col nine">
          <input
            type="text"
            required
            bind:this={lastnamekana.input}
            bind:value={$apply.lastnamekana}
            on:blur={lastnamekana.validate}
            id="lastnamekana"
            placeholder="セイ"
            class="w100" />
          <div class="ifinvalid">{lastnamekana.invalidmsg}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="col three"><label for="firstnamekana">メイ</label></div>
        <div class="col nine">
          <input
            type="text"
            required
            bind:this={firstnamekana.input}
            bind:value={$apply.firstnamekana}
            on:blur={firstnamekana.validate}
            id="firstnamekana"
            placeholder="メイ"
            class="w100" />
          <div class="ifinvalid">{firstnamekana.invalidmsg}</div>
        </div>
      </div>
    </fieldset>
    <div class="input-group">
      <div class="col three"><label for="tel">電話番号</label></div>
      <div class="col nine">
        <input
          type="text"
          required
          bind:this={tel.input}
          bind:value={$apply.tel}
          on:blur={tel.validate}
          id="tel"
          placeholder="電話番号"
          class="w100" />
        <div class="hint">ハイフンなしでご入力ください</div>
        <div class="ifinvalid">{tel.invalidmsg}</div>
      </div>
    </div>
    <fieldset>
      <div class="row">
        <div class="col three"><legend>住所</legend></div>
        <div class="col nine as-end">都道府県、市区町村は郵便番号を入力後に自動セットされます。<br />※自動セットされない場合は[郵便番号から住所入力]ボタンを押してください。</div>
      </div>
      <div class="input-group">
        <div class="col three"><label for="zipcode">郵便番号</label></div>
        <div class="col nine">
          <div class="input-addon">
            <input
            type="text"
            required
            bind:this={zipcode.input}
            bind:value={$apply.zipcode}
            on:blur={zipcode.validate}
            id="zipcode"
            placeholder="郵便番号" />
            <span class="append">
              <button
              type="button"
              on:click={zipcode.validate}
              class="btn-secondary">郵便番号から住所入力</button>  
            </span>
            <div class="hint">ハイフンなしでご入力ください</div>
            <div class="ifinvalid">{zipcode.invalidmsg}</div>
          </div>
        </div>
      </div>
      <div class="input-group">
        <div class="col three"><label for="prefecture">都道府県</label></div>
        <div class="col nine">
          <select
            bind:this={prefecture.input}
            bind:value={$apply.prefecture}
            on:change={prefecture.validate}
            on:blur={prefecture.validate}
            readonly
            class="w100"
            id="prefecture">
            <option disabled selected class="unselectable" value="">都道府県</option>
            {#each prefectureoptions as option}
            <option value={option}>{option}</option>
            {/each}
          </select>
          <div class="ifinvalid">{prefecture.invalidmsg}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="col three"><label for="city">市区町村</label></div>
        <div class="col nine">
          <select
            type="text"
            required
            readonly
            bind:this={city.input}
            bind:value={$apply.city}
            on:blur={city.validate}
            class="w100"
            placeholder="市区町村"
            id="city">
            <option disabled selected class="unselectable" value="">市区町村</option>
            {#each cityoptions as option}
            <option value={option}>{option}</option>
            {/each}
          </select>
          <div class="ifinvalid">{city.invalidmsg}</div>
        </div>
      </div>
      {#if $addressinput}
      <div class="input-group">
        <div class="col three"><label for="address">番地以降</label></div>
        <div class="col nine">
          <input
            type="text"
            required
            bind:this={address.input}
            bind:value={$apply.address}
            on:blur={address.validate}
            id="address"
            placeholder="番地以降"
            class="w100" />
          <div class="ifinvalid">{address.invalidmsg}</div>
        </div>
      </div>
      {/if}
    </fieldset>
    <div class="input-group">
      <div class="col three"><label for="age">年代</label></div>
      <div class="col nine">
        <select
          bind:this={age.input}
          bind:value={$apply.age}
          on:change={age.validate}
          on:blur={age.validate}
          class="w100"
          id="age">
          <option disabled selected class="unselectable" value="">年代</option>
          <option>10代未満</option>
          <option>10代</option>
          <option>20代</option>
          <option>30代</option>
          <option>40代</option>
          <option>50代</option>
          <option>60代</option>
          <option>70代以上</option>
        </select>
        <div class="ifinvalid">{age.invalidmsg}</div>
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="gender">性別</label></div>
      <div class="col nine">
        <select
          bind:this={gender.input}
          bind:value={$apply.gender}
          on:change={gender.validate}
          on:blur={gender.validate}
          class="w100"
          id="gender">
          <option disabled selected class="unselectable" value="">性別</option>
          <option>男性</option>
          <option>女性</option>
          <option>その他</option>
        </select>
        <div class="ifinvalid">{gender.invalidmsg}</div>
      </div>
    </div>
    <fieldset>
      <legend>{$quantityfield.legend}</legend>
      <div class="input-group">
        <div class="col three"><label for="quantity">{$quantityfield.label}</label></div>
        <div class="col nine">
          <select
            bind:this={quantity.input}
            bind:value={$apply.quantity}
            on:change={quantity.validate}
            on:blur={quantity.validate}
            class="w100"
            id="quantity">
            <option disabled selected class="unselectable" value="">
              セット数
            </option>
            {#each $quantityoptions as qo}
            <option value={qo.value}>{qo.text}</option>
            {/each}
          </select>
          <div class="ifinvalid">{quantity.invalidmsg}</div>
        </div>
      </div>
    </fieldset>
    <div class="mt-1 mb-1 flex jc-center">
      <button type="submit" class="btn-primary">確認</button>
    </div>
  </form>
</div>
